/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import LookupElements from "./lookup-elements";
import { useMediaQuery, useTheme } from '@mui/material';

const useRowStyles = makeStyles({
    cellLeft: {
        textAlign: 'left !important',
    },
});

const ExpandableRow = ({ row, open }) => {
    const classes = useRowStyles();

    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box margin={1} css={css`float:left;`}>
                        <Table size="small" css={css`float:left;min-width:350px;width:auto`}>
                            <TableBody>
                                {!isMdUp && (
                                    <TableRow key={`${row.serialNumber}_version`}>
                                        <TableCell className={classes.cellLeft}>VERSION:</TableCell>
                                        <TableCell className={classes.cellLeft}>{row.version}</TableCell>
                                    </TableRow>
                                )}
                                <TableRow key={`${row.serialNumber}_oem`}>
                                    <TableCell className={classes.cellLeft}>OEM:</TableCell>
                                    <TableCell className={classes.cellLeft}>{row.oem}</TableCell>
                                </TableRow>
                                <TableRow key={`${row.serialNumber}_type`}>
                                    <TableCell className={classes.cellLeft}>TYPE:</TableCell>
                                    <TableCell className={classes.cellLeft}>{row.type}</TableCell>
                                </TableRow>
                                {!isLgUp && (
                                    <TableRow key={`${row.serialNumber}_voltage`}>
                                        <TableCell className={classes.cellLeft}>VOLTAGE:</TableCell>
                                        <TableCell className={classes.cellLeft}>{row.voltage}</TableCell>
                                    </TableRow>
                                )}
                                {!isLgUp && (

                                    <TableRow key={`${row.serialNumber}_boudrate`}>
                                        <TableCell className={classes.cellLeft}>BOUDRATE:</TableCell>
                                        <TableCell className={classes.cellLeft}>{row.boudrate}</TableCell>
                                    </TableRow>
                                )}
                                {!isSmUp && (
                                    <TableRow key={`${row.serialNumber}_remoteDownload`}>
                                        <TableCell className={classes.cellLeft}>REMOTE DOWNLOAD:</TableCell>
                                        <TableCell className={classes.cellLeft}>
                                            <LookupElements row={row}></LookupElements>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    );
};

export default ExpandableRow;